import { baseTranslations } from './base';

// Core translations with additional keys merged properly
export const coreTranslations = {
  FR: {
    ...baseTranslations.FR,
    refresh_limit_reached: "Limite de rafraîchissement atteinte pour aujourd'hui",
    refresh_limit_reached_account: "Limite de rafraîchissement atteinte pour ce compte",
    refresh_limit_reached_user: "Limite de rafraîchissement atteinte pour tous vos comptes",
    refreshes_per_day: "rafraîchissements par jour",
    connection_required: "Ce compte n'est pas connecté. Pour que Amplr AI puisse fonctionner et générer des résultats, vous devez connecter votre compte dans les paramètres. Si vous avez besoin d'aide, n'hésitez pas à nous contacter.",
    or: 'ou',
    continue_with_google: 'Continuer avec Google',
    account_refresh_limit_reached: 'Limite de rafraîchissement atteinte pour ce compte (3 par jour). Réessayez demain.',
    user_refresh_limit_reached: 'Limite de rafraîchissement atteinte pour tous vos comptes (10 par jour). Réessayez demain.',
    refresh_limit_reached: 'Limite de rafraîchissement atteinte. Réessayez plus tard.',
    refreshes_remaining: 'rafraîchissements restants'
  },
  EN: {
    ...baseTranslations.EN,
    refresh_limit_reached: "Refresh limit reached for today",
    refresh_limit_reached_account: "Refresh limit reached for this account",
    refresh_limit_reached_user: "Refresh limit reached for all your accounts",
    refreshes_per_day: "refreshes per day",
    connection_required: "This account is not connected. For Amplr AI to work and generate results, you need to connect your account in settings. If you need help, don't hesitate to contact us.",
    or: 'or',
    continue_with_google: 'Continue with Google',
    account_refresh_limit_reached: 'Refresh limit reached for this account (3 per day). Try again tomorrow.',
    user_refresh_limit_reached: 'Refresh limit reached for all your accounts (10 per day). Try again tomorrow.',
    refresh_limit_reached: 'Refresh limit reached. Try again later.',
    refreshes_remaining: 'refreshes remaining'
  },
  ES: {
    ...baseTranslations.ES,
    refresh_limit_reached: "Límite de actualización alcanzado para hoy",
    refresh_limit_reached_account: "Límite de actualización alcanzado para esta cuenta",
    refresh_limit_reached_user: "Límite de actualización alcanzado para todas tus cuentas",
    refreshes_per_day: "actualizaciones por día",
    connection_required: "Esta cuenta no está conectada. Para que Amplr AI funcione y genere resultados, debes conectar tu cuenta en la configuración. Si necesitas ayuda, no dudes en contactarnos.",
    or: 'o',
    continue_with_google: 'Continuar con Google',
    account_refresh_limit_reached: 'Límite de actualización alcanzado para esta cuenta (3 por día). Inténtalo de nuevo mañana.',
    user_refresh_limit_reached: 'Límite de actualización alcanzado para todas tus cuentas (10 por día). Inténtalo de nuevo mañana.',
    refresh_limit_reached: 'Límite de actualización alcanzado. Inténtalo más tarde.',
    refreshes_remaining: 'actualizaciones restantes'
  },
  RU: {
    ...baseTranslations.RU,
    refresh_limit_reached: "Достигнут лимит обновлений на сегодня",
    refresh_limit_reached_account: "Достигнут лимит обновлений для этого аккаунта",
    refresh_limit_reached_user: "Достигнут лимит обновлений для всех ваших аккаунтов",
    refreshes_per_day: "обновлений в день",
    connection_required: "Этот аккаунт не подключен. Для работы Amplr AI и получения результатов необходимо подключить ваш аккаунт в настройках. Если вам нужна помощь, не стесняйтесь обращаться к нам.",
    or: 'или',
    continue_with_google: 'Продолжить с Google',
    account_refresh_limit_reached: 'Достигнут лимит обновлений для этого аккаунта (3 в день). Попробуйте завтра.',
    user_refresh_limit_reached: 'Достигнут лимит обновлений для всех ваших аккаунтов (10 в день). Попробуйте завтра.',
    refresh_limit_reached: 'Достигнут лимит обновлений. Попробуйте позже.',
    refreshes_remaining: 'обновлений осталось'
  }
};

// Export for backward compatibility
export const translations = coreTranslations;